import React, { createContext, useContext } from 'react'

import { type StoreApi, createStore, useStore } from 'zustand'

interface PopoverState {
  openPopoverId: string | null
  setOpenPopoverId: (id: string | null) => void
}

const PopoverStoreContext = createContext<StoreApi<PopoverState> | null>(null)

interface PopoverProviderProps {
  children: React.ReactNode
}

export const PopoverProvider: React.FC<PopoverProviderProps> = ({
  children,
}) => {
  const [store] = React.useState(() =>
    createStore<PopoverState>((set) => ({
      openPopoverId: null,
      setOpenPopoverId: (id: string | null) => set({ openPopoverId: id }),
    })),
  )

  return (
    <PopoverStoreContext.Provider value={store}>
      {children}
    </PopoverStoreContext.Provider>
  )
}

export const usePopoverStore = <T,>(
  selector: (state: PopoverState) => T,
): T => {
  const store = useContext(PopoverStoreContext)
  if (!store) {
    throw new Error(
      'PopoverStoreProvider is missing. Make sure to wrap your component tree with <PopoverProvider>.',
    )
  }
  return useStore(store, selector)
}

export const useOpenPopoverId = () =>
  usePopoverStore((state) => state.openPopoverId)

export const useSetOpenPopoverId = () =>
  usePopoverStore((state) => state.setOpenPopoverId)
